<template>
  	<div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
			<h2 class="mb-0">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <div class="breadcrumbactive">
                        <div>
                            <span @click="showListView()" class="pointer">Sales Forecast</span>
							<div v-if="set_target">Assign Sales Target</div>
                        </div>
                    </div>
					<div class="d-flex flex-wrap align-items-center margin711">
						<button v-if="!view_sale && !set_target" class="btn btn-new-primary btn-wide px-6 mr-4 sales-btn" @click="showFilters()"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/filter_icon.svg" style="margin-right: 8px;"> Filter</button>
                    	<button v-if="!view_sale && !set_target" class="btn btn-new-primary btn-wide px-6 mr-4 sales-btn" disabled><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/export-excel-white.svg" style="margin-right: 8px; margin-top: -2px"> Export to Excel</button>
                    	<button class="btn btn-new-green btn-wide px-6 bg-color margin571" v-if="loggedInUser.user_role == 'sales_manager' && !set_target && userPermissions.sales_forecast.permitted_actions.create" @click="createSalesForecast()"> + Create Sales Forecast</button>
                	</div>
                </div>
            </h2>
			<!-- <div class="filterSelectedChips mb-3" v-if="showfilterData.sale_forecast_name.length || showfilterData.territory.length || showfilterData.product.length || showfilterData.forecast_period.length || showfilterData.status.length || showfilterData.targeted_sale || showfilterData.actual_sale">
				<div class="pull-right pointer resetChips" style="bottom: 7px !important;" @click="removeAllChips()"><i class="icon icon-close text-white fs-20"></i></div>
				<div class="d-flex align-items-center flex-wrap">
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.sale_forecast_name.length">Sales Forecast Name</span>
					<span v-for="(name,sf_index) in showfilterData.sale_forecast_name" :key="sf_index">
						<span class="filterChips" @click="removeChips(name,'sales_forecast_name')">
							{{name.name}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.territory.length">Territory</span>
					<span v-for="(territory,territory_index) in showfilterData.territory" :key="territory_index">
						<span class="filterChips" @click="removeChips(territory,'territory')">
							{{territory.name}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.product.length">Product</span>
					<span v-for="(product,product_index) in showfilterData.product" :key="product_index">
						<span class="filterChips" @click="removeChips(product,'product')">
							{{product.name}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.forecast_period.length">Forecast Period</span>
					<span v-for="(forecast_period,forecast_period_index) in showfilterData.forecast_period" :key="forecast_period_index">
						<span class="filterChips" @click="removeChips(forecast_period,'forecast_period')">
							{{forecast_period}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.status.length">Status</span>
					<span v-for="(status,status_index) in showfilterData.status" :key="status_index">
						<span class="filterChips" @click="removeChips(status,'status')">
							{{status}}
							<i class="icon icon-close fs-12"></i>
						</span>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.targeted_sale">Targeted Sale</span>
					<span class="filterChips" v-if="showfilterData.targeted_sale" @click="removeChips(showfilterData.targeted_sale,'targeted_sale')">
						{{showfilterData.targeted_sale}}
						<i class="icon icon-close fs-12"></i>
					</span>
					<span class="font-weight-bold text-white p-2" v-show="showfilterData.actual_sale">Actual Sale</span>
					<span class="filterChips" v-if="showfilterData.actual_sale" @click="removeChips(showfilterData.actual_sale,'actual_sale')">
						{{showfilterData.actual_sale}}
						<i class="icon icon-close fs-12"></i>
					</span>
				</div>
			</div> -->
			<div v-if="salesForeCastLength.length == 0" class="start-overflow">
                <div class="create-company-container w-100 ">
                    <div class="main-div">
                        <div class="create-company-header d-flex align-items-center justify-content-between">
                            <span class="fs-14  pl-3 text-white ml-3">Sales Forecast</span>
						</div>
					</div>
					<div class="align-center">
						<div class="d-flex justify-content-center">
							<div class="d-flex flex-column">
            					<img src="/static/images/images-new-theme/search-deal-image.png" alt="">
								<p class="input-label ml-4 ">Set target and Create Forecast!!</p>
        					</div>
						</div>
					</div>
				</div>
            </div>
 			<div v-else>
				<div v-if="show_lists">
					<list-view @editSalesForecast="createSalesForecast" @assignTarget="assignTarget"></list-view>
				</div>
			 	<div v-if="set_target">
					<create-settarget></create-settarget>
				</div>
			</div>
		</div>
		<div v-show="display_filters" class="filters-background filterblock">
			<div class="scm-filters fadeInDown sales-filters" :class="{'fadeInUp':hide_filters == true}">
				<filter-data :showfilterData="showfilterData" @hideFilters="hideFilters" @UpdateByFilter="UpdateByFilter"></filter-data>
			</div>
		</div>
		<CreateSalesforecast @hideCreateSalesForecast="hideCreateSalesForecast" v-if="create_sales_forecast" modal_name="Create-Sales"/>
  	</div>
</template>

<script>
import ListView from './ListView'
import CreateSalesforecast from './CreateSalesforecast';
import FilterData from './FilterData';
import CreateSettarget from './CreateSetTarget';
import { EventBus } from '../eventBus/nav-bar-event';
export default {
	components: {
		ListView,
		CreateSalesforecast,
		FilterData,
		CreateSettarget,
	},
	data() {
		return {
			hide_filters: false,
            display_filters: false,
			show_lists: true,
			set_target:false,
			view_sale:false,
			filters: {
                sale_forecast_name: [],
				product_id: [],
				territory: [],
				forecast_period: [],
				status: [],
				targeted_sale: "",
				actual_sale: ""
            },
            showfilterData:{
                sale_forecast_name: [],
				product_id: [],
				territory: [],
				forecast_period: [],
				status: [],
				targeted_sale: "",
				actual_sale: ""
			},
			create_sales_forecast: false,
			selected_id: null,
		}
	},
	methods: {
		hideCreateSalesForecast(){
			this.create_sales_forecast= false
		},
		createSalesForecast() {
			this.create_sales_forecast= true
			setTimeout(() => {
				if(this.set_target){
					this.set_target= false;
					this.show_lists = true;
				}
				this.$modal.show("Create-Sales");
			}, 500);
		},
		showFilters(){
            if(this.display_filters) {
                this.hide_filters = true
                setTimeout(() => {
                    this.display_filters = false
                    this.hide_filters = false
                }, 500);
            }
            else{
                this.display_filters = true
            }
        },
        hideFilters() {
            this.hide_filters = true
            setTimeout(() => {
                this.display_filters = false
                this.hide_filters = false
            }, 500);
		},
		UpdateByFilter(params){
            this.skip = 0
			this.limit = 10
			// console.log(params)
            this.showfilterData = {
				sale_forecast_name: params.value.sale_forecast_name,
				product_id: params.value.product_id,
				territory: params.value.territory,
				forecast_period: params.value.forecast_period,
				status: params.value.status,
				targeted_sale: params.value.targeted_sale,
				actual_sale: params.value.actual_sale
            }
            this.filters = {
				sale_forecast_name: params.value1.sale_forecast_name,
				product: params.value1.product_id,
				territory: params.value1.territory,
				forecast_period: params.value1.forecast_period,
				status: params.value1.status,
				targeted_sale: params.value1.targeted_sale,
				actual_sale: params.value1.actual_sale
            }
            EventBus.$emit("load_sales_forecast",this.filters)
			EventBus.$emit("filter_sales_forecast",this.showfilterData)
		},
		// removeChips(value,key){
        //     let params = {
        //         value:value,
        //         key:key
        //     }
        //     EventBus.$emit('removechip',params)
        // },
        // removeAllChips(){
        //     this.filters = {
        //         sale_forecast_name: [],
		// 		product: [],
		// 		territory: [],
		// 		forecast_period: [],
		// 		status: [],
		// 		targeted_sale: "",
		// 		actual_sale: ""
        //     }
        //     this.showfilterData = {
        //         sale_forecast_name: [],
		// 		product: [],
		// 		territory: [],
		// 		forecast_period: [],
		// 		status: [],
		// 		targeted_sale: "",
		// 		actual_sale: ""
        //     }
        //     EventBus.$emit('removeAllchip')
        //     if(!this.display_filters) {
        //         EventBus.$emit("load_sales_forecast",this.filters)
        //     }
		// },
		updatePathParams($router, newParams) {
			// Retrieve current params
			const currentParams = $router.currentRoute.params;
			// Create new params object
			const mergedParams = { ...currentParams, newParams };
			// console.log(mergedParams)
			$router.push({
				params: {id: mergedParams.newParams.id}
			});
			this.$forceUpdate()
		},
		assignTarget(id){
			this.set_target = true;
			this.view_sale = false;
			this.show_lists = false
			this.updatePathParams(this.$router, { id: id });
		},
		showListView(){
			this.set_target = false;
			this.view_sale = false;
			this.show_lists = true
			this.updatePathParams(this.$router, { id: "list" });
		},
	},
	mounted() {
		EventBus.$on("showSalesForecastPopup", () => {
			if(this.create_sales_forecast == false){
				this.createSalesForecast()
			}	
        });
		EventBus.$on("target", (value) => {
			this.set_target = value;
			this.view_sale = false;
			this.show_lists = false;
		});
		EventBus.$on("list", (value) => {
			this.show_lists = value;
			this.view_sale = false
			this.set_target = false;
			this.$route.params.id = "list"
		});
		if(this.$route.params.id != 'list'){
			this.show_lists = false;
			this.set_target = true;
		}
		EventBus.$on("sales_forecast", () => {
			if(this.create_sales_forecast == false){
				this.createSalesForecast()
			}
		})
		if(this.$route.params.hasOwnProperty('name') && this.$route.params.name == true){
			this.createSalesForecast()
		}
		
	  },
	  computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
		},
		salesForeCastLength(){
			return this.$store.state.sales_forecast_length;
		},
		userPermissions(){
			return this.$store.getters.userPermissions;
		}
    }
}
</script>

<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .create-company-container {
        background-color: #fff;
        padding: 30px 0 0px 0;
        border-radius: 6px;
    }
    .create-company-header {
        padding: 9.9px 15px;
        background-color: #005dae;
    }
	.input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: center;
        color: #005dae;
        padding: 0 0 6px 10px;
        font-size: 14px;
    }
	.align-center{
		text-align: center;
		height: 500px;
	}
	.bg-color{
		background-color: #128807;
	}
	.sales-filters{
        height: 425px !important;
		background: #e6ecff;
		right: 30px;
    	top: 160px;
    }
	.sales-btn{
		background-color: #00448b;
	}
	@media only screen and (max-width: 711px) {
        .margin711{
            margin-bottom: 10px !important;
        }
    }
	@media only screen and (max-width: 571px) {
        .margin571{
            margin-top: 10px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/SalesCast.vue